import { ContactInformationType } from 'b2b-apps/shop/myAccount/accountDetails/api/Details.types';
import {
  CLEAR_ACCOUNT_DETAILS,
  FETCH_DETAILS,
  FETCH_DETAILS_FULFILLED,
  FETCH_DETAILS_REJECTED,
  UPDATE_CONTACT_INFORMATION,
} from './actionTypes';
import {
  ClearAccountDetailsAction,
  DetailsType,
  FetchDetailsAction,
  FetchDetailsFulfilledAction,
  FetchDetailsRejectedAction,
  UpdateContactInformationAction,
  UpdateContactInformationCallbackType,
} from './types';

const fetchDetails = (): FetchDetailsAction => ({
  type: FETCH_DETAILS,
});

const fetchDetailsFulfilled = (
  response: DetailsType,
): FetchDetailsFulfilledAction => ({
  type: FETCH_DETAILS_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchDetailsRejected = (
  error: ErrorType,
): FetchDetailsRejectedAction => ({
  type: FETCH_DETAILS_REJECTED,
  payload: {
    error,
  },
});

const clearAccountDetails = (): ClearAccountDetailsAction => ({
  type: CLEAR_ACCOUNT_DETAILS,
});

const updateContactInformation = (
  contactInformation: ContactInformationType,
  callback: UpdateContactInformationCallbackType,
): UpdateContactInformationAction => ({
  type: UPDATE_CONTACT_INFORMATION,
  payload: {
    contactInformation,
    callback,
  },
});

export {
  clearAccountDetails,
  fetchDetails,
  fetchDetailsFulfilled,
  fetchDetailsRejected,
  updateContactInformation,
};
